import { IThemeProps, HeaderStyle, ButtonStyle } from "../types";
import { assignProps } from "../utils";

const blueGol: string = "#20b8cf";
const orange: string = "#e7601c";
const greenDark: string = "#2fcc95";
// const greenLight: string = "#9ac328";
// const yellow: string = "#ffcc33";
const blackLight: string = "#222222";
const kei: string = "#646470"; // kei
const gray: string = "#888888";
const grayLight: string = "#ececec";
const grayRegular: string = "#dddddd";
const grayMedium: string = "#bbbbbb";
const white: string = "#ffffff";
const error: string = "#f44336";

export class Theme {
  public primaryColor: string = blueGol;
  public secondaryColor: string = orange;
  public backgroundColor: string = white;
  public headerBackgroundColor: string = blueGol;
  public bodyBackgroundColor: string = white;
  public headerStyle: HeaderStyle = HeaderStyle.contained;
  public invertFontColor: string = white;
  public textColor: string = kei;
  public textColorGray: string = gray;
  public textColorDarken: string = blackLight;
  public disabledColor: string = grayMedium;
  public headerHeight: string = "50px";
  public footerHeight: string = "60px";
  public informationTextBackgroundColor = "rgba(248, 248, 248, 0.9)";
  public legendBorderGray: string = gray;
  public reservationSuccess: string = greenDark;
  public success: string = orange;
  public buttonStyle: ButtonStyle = ButtonStyle.text;
  public buttonBackgroundOnHover = grayRegular;
  public error: string = error;
  public voucherBackgroundColor: string = grayLight;
  public voucherTextColor: string = grayMedium;
  public backgroundTransparentWhite: string = "rgba(255, 255, 255, 0.8)";
  public isBackground: boolean = false;

  public globalPadding: string = "8px";

  constructor(props?: IThemeProps) {
    if (props) {
      assignProps(this, props);
    }
  }
}
